export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="container hero__inner">
  <div className="badge">KTS. TRƯƠNG ĐÌNH NGUYỄN TRƯỜNG</div>
        <h1>Kiến trúc & Nội thất tinh tế, nâng tầm không gian sống</h1>
        <p>
          K.A.I Architect chuyên thiết kế nhà ở, biệt thự, căn hộ và nội thất theo phong cách hiện đại,
          tối ưu công năng, thẩm mỹ và ngân sách thực tế.
        </p>
        <div className="actions">
          <a href="#projects" className="btn btn--primary">Xem công trình</a>
          <a href="#contact" className="btn">Nhận tư vấn</a>
        </div>
      </div>
    </section>
  );
}
